import { useAppDispatch, useAppSelector, useHandlePageNavigate } from "./hooks";
import {
  searchSocialAsync,
  selectSocialSearchStatus,
  selectAllReportNotesList,
  clearSpecificReportNotes,
} from "../features/reports/reportsSlice";
import { setSocialSearch } from "../features/multisearch/multisearchSlice";
import { useGetSpecificReportNotesDispatch } from "./notesHook";
import { sendMemberEventAsync } from "../features/admin/adminSlice";

export type SearchSocialParams = string;

type UseSocialSearchHook = () => (
  search: SearchSocialParams,
  pullLocation: string,
) => void;

/* Social Search */
const useSocialSearchDispatch: UseSocialSearchHook = () => {
  const dispatch = useAppDispatch();
  const socialSearchStatus = useAppSelector(selectSocialSearchStatus);
  const pageNavigate = useHandlePageNavigate();
  const allReportNotesList = useAppSelector(selectAllReportNotesList);
  const getSpecificReportNotes = useGetSpecificReportNotesDispatch();

  const searchSocial = (search: SearchSocialParams, pullLocation: string) => {
    if (socialSearchStatus === "loading") return;
    pageNavigate("/social-report");
    dispatch(searchSocialAsync({ search: search }))
      .unwrap()
      .then(result => {
        if (result.success) {
          dispatch(setSocialSearch(search));
          if (
            allReportNotesList?.some(
              notes =>
                notes &&
                notes.reportType === "social" &&
                notes.token.toUpperCase() === search.toUpperCase(),
            )
          ) {
            getSpecificReportNotes({
              reportType: "social",
              reportParams: {
                socialToken: search.toUpperCase(),
              },
            });
          } else {
            dispatch(clearSpecificReportNotes());
          }
          dispatch(
            sendMemberEventAsync({
              EventAction: "Search",
              EventCategory: "Social",
              MetaData: JSON.stringify({ "pull location": pullLocation }),
            }),
          );
        }
      })
      .catch(error => {
        console.log(error.message);
        pageNavigate("/");
      });
  };

  return searchSocial;
};

export { useSocialSearchDispatch };
